<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">

      <mat-form-field>
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.name" matInput name="name">
      </mat-form-field>

      <mat-form-field>
        <mat-label>Serial</mat-label>
        <input [(ngModel)]="search.serial" matInput name="serial">
      </mat-form-field>

      <ac-input-container label="Administrative State"   >
        <ac-select
          [(acModel)]="search.adminState"
          [items]="search.adminStateSearchOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

    </div>

    <div class="search-column">

      <mat-form-field>
        <mat-label>Host name</mat-label>
        <input [(ngModel)]="search.hostname" matInput name="hostname">
      </mat-form-field>

      <mat-form-field>
        <mat-label>IP Address</mat-label>
        <input [(ngModel)]="search.ipAddr" matInput name="ip-addr">
      </mat-form-field>

      <ac-input-container label="Operative State"   >
        <ac-select
          [(acModel)]="search.operState"
          [items]="search.operStateOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

    </div>
  </div>
</arm-dialog>

